module.exports = __webpack_public_path__ + "img/clothes-hanger.cccc8427.svg";